var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStopIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 24,
    viewBox: "0 0 15 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4258bf",
    d: "M8.125 3c0-.31-.28-.562-.625-.562-2.642 0-4.792 1.935-4.792 4.313 0 .31.28.562.625.562s.625-.252.625-.562c0-1.758 1.589-3.188 3.542-3.188.345 0 .625-.252.625-.562zM15 6.75c0 3.729-3.358 6.75-7.5 6.75C3.358 13.5 0 10.48 0 6.75 0 3.024 3.358 0 7.5 0 11.642 0 15 3.023 15 6.75zm-9.167 8.107zm0 0c.541.09 1.097.144 1.667.144.57 0 1.125-.054 1.667-.144v7.345L8.02 23.75c-.247.334-.792.334-1.04 0l-1.147-1.548z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopIcon);
export default __webpack_public_path__ + "static/media/stop-icon.d1b73f4d911f9084e2044b5a342d66bf.svg";
export { ForwardRef as ReactComponent };